<template>
  <img src="/assets/back_arrow.svg" @click="$emit('onClick')">
</template>

<script>
export default {
  name: "BackButton",
}
</script>
